/* @flow */
import React from "react";
import { ErrorWrap } from "../helpers/error";
import { Header, Icon } from "semantic-ui-react";
import { t } from "../constant/translations";

type Props = { error?: Object };

const Error = (props: Props) => {
  const error = ErrorWrap.fromError(props.error);
  return (
    <Header textAlign={"center"} icon>
      <Icon name={"x"} />
      {error.getCode()}
      <Header.Subheader>{t("error.page_not_found")}</Header.Subheader>
    </Header>
  );
};

export default Error;
